module.exports = __webpack_public_path__ + "img/clinicarx-logo-white.04c80504.svg";